<div class="openid__authentication flex flex-col gap-4">
  <div class="or__switch flex items-center gap-6">
    <span></span>
    <p translate>OR</p>
    <span></span>
  </div>

  <div class="auth__methods flex justify-center">
    <button
      class="method flex justify-center items-center"
      class="google__login"
      id="loginByGoogleBtn"
    >
      <!-- <div inlineSVG="auth/google.svg"></div>
      <p>Continue with Google</p> -->
    </button>

    <!-- <button class="method flex justify-center items-center gap-4">
      <div inlineSVG="auth/facebook.svg"></div>
      <p>Continue with Google</p>
    </button> -->
  </div>
</div>
